<script>
import GraphApexChart from '../../dashboard/GraphApexChart.vue'
export default {
  template: `<div>
              <graph-apex-chart :data='graphBar()'></graph-apex-chart>
             </div>`,
  data(){
    return {
      apex: {
        series: [
          {
            name: 'Es',
            data: [
              {
                x: 'Datos',
                y: 12,
                goals: [
                  {
                    name: 'Deberia ser',
                    value: 14,
                    strokeWidth: 2,
                    strokeDashArray: 2,
                    strokeColor: '#775DD0'
                  }
                ]
              },
            ]
          }
        ],
        options: {
          chart: {
            width: '100%',
            height: '100%',
            redrawOnParentResize: true,
            redrawOnWindowResize: false,
            type: 'bar',
            toolbar: {
              show: false,
            },
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              colors: {
                backgroundBarColors: ['#f9f8f8'],
              },
            },
          },
          colors: ['#d9d2e9'],
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#242732'],
              fontSize: '16px',
            },
            formatter: (val) => val,
          },
          tooltip: {
            enabled: false,
          },
          grid: {
            show: false,
          },
          xaxis: {
            show: false,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          states: {
            hover: {
              filter: {
                type: 'none',
              },
            },
          },
          yaxis: {
            max: 100,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        type: 'bar',
      },
      rangos: {
        baja: '#225ea8',
        media: '#4cc488',
        alta: '#fcdd82',
        muyAlta: '#fc8c82'
      },
    }
  },
  methods:{
    // Graph
    graphBar() {
      const params = this.params
      const data = params.data
      const field = params.colDef.field
      if (data) {
        // Value _hoy
        let sub = field
        let value = (data[sub].p).toFixed(1)

        // Target _futuro
        sub = field.split('_')[0] + "_futuro"
        let target = (data[sub].p).toFixed(1)

        return {
          series: [
            {
              name: 'Es',
              data: [
                {
                  x: 'Datos',
                  y: value,
                  goals: [
                    {
                      name: 'Debería ser',
                      value: target,
                      strokeWidth: 2,
                      strokeDashArray: 2,
                      strokeColor: '#775DD0'
                    }
                  ]
                },
              ]
            }
          ],
          options: {
            chart: {
              width: '100%',
              height: '100%',
              redrawOnParentResize: true,
              redrawOnWindowResize: false,
              type: 'bar',
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true,
              },
              events: {
                mouseMove: this.showTooltip,
                mouseLeave: this.hideTooltip,
              }
            },
            plotOptions: {
              bar: {
                horizontal: true,
                colors: {
                  backgroundBarColors: ['#f9f8f8'],
                },
              },
            },
            colors: ['#a9e1e1'],
            dataLabels: {
              enabled: true,
              offsetY: 9,
              style: {
                colors: ['#242732'],
                fontSize: '15px',
              },
              formatter: (val) => val,
            },
            tooltip: {
              enabled: false,
              shared: true,
              intersect: false,
            },
            grid: {
              show: false,
              padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              },
              margin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
            xaxis: {
              show: false,
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            states: {
              hover: {
                filter: {
                  type: 'none',
                },
              },
            },
            yaxis: {
              max: 100,
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
            },
          },
          width: '240',
          height: '50',
          type: 'bar',
        }
      }
    },
    showTooltip(event, chartContext, { dataPointIndex }) {
      // Obtén los datos del punto específico donde el mouse entró
      const seriesName = chartContext.w.config.series[0].name;
      const dataValue = chartContext.w.config.series[0].data[dataPointIndex+1].y;
      const valueColor = chartContext.w.config.colors[0];
      const targetName = chartContext.w.config.series[0].data[dataPointIndex+1].goals[0].name
      const dataTarget = chartContext.w.config.series[0].data[dataPointIndex+1].goals[0].value
      const targetColor = chartContext.w.config.series[0].data[dataPointIndex+1].goals[0].strokeColor
      const gap = Math.abs(dataTarget - dataValue).toFixed(1)
      let gapColor = '#fffff';
      let range = '';
      if(gap < 5){
        // 0- 5 : baja
        gapColor = this.rangos.baja
        range = 'Baja'
      }
      else if(gap >= 5 && gap < 10){
        // 5- 10: media
        gapColor = this.rangos.media
        range = 'Media'
      }
      else if(gap >= 10 && gap < 20){
        // 10 - 20: alta
        gapColor = this.rangos.alta
        range = 'Alta'
      }
      else if(gap >= 20){
        // 20>: muy alta
        gapColor = this.rangos.muyAlta
        range = 'Muy alta'
      }
      /*
      * left: 340px;
      * top: 1464px;
      * */
      // Personaliza el contenido del tooltip
      const tooltipContent = `
        <div class='is-flex is-size-7'>
          <div class='boxElementGraph' style='background-color: ${valueColor} !important;'>
          </div> <span class='has-text-weight-bold'>${seriesName}</span>: ${dataValue}
        </div>
        <div class='is-flex is-size-7'>
            <div class='boxElementGraph' style='background-color: ${targetColor} !important;'>
            </div>
            <span class='has-text-weight-bold'>${targetName}</span>: ${dataTarget}
        </div>
        <div class='is-flex is-size-7'>
            <div class='boxElementGraph' style='background-color: ${gapColor} !important;'>
            </div>
            <span class='has-text-weight-bold'>Brecha</span>: ${gap} ${range}
        </div>
    `;

      setTimeout(() => {
        // Muestra el tooltip en la posición del mouse
        const tooltipElement = document.getElementById('tooltipApexChart');
        const tooltipWidth = 170
        tooltipElement.innerHTML = tooltipContent;

        // Coordenadas proporcionadas por ApexCharts

        // Calcula la posición del tooltip en relación con el evento del mouse
        const adjustedLeft = event.pageX - 10; // Ajusta el valor según sea necesario
        const adjustedTop = event.pageY - 280; // Ajusta el valor según sea necesario


        // Comprobar si el tooltip se sale de la pantalla en el lado derecho
        if (adjustedLeft + tooltipWidth + 35 > window.innerWidth) {
          // Si se sale, ajustar la posición hacia la izquierda
          tooltipElement.style.left = adjustedLeft - tooltipWidth - 35 + 'px';
        } else {
          tooltipElement.style.left = adjustedLeft + 'px';
        }

        tooltipElement.style.top = adjustedTop + 'px';

        tooltipElement.style.maxWidth = tooltipWidth + 'px'
        tooltipElement.style.display = 'block';
        tooltipElement.style.opacity = '1';
      }, 100); // Ajusta el retardo según sea necesario
    },
    hideTooltip() {
      // Oculta el tooltip cuando el mouse sale del punto
      const tooltipElement = document.getElementById('tooltipApexChart');
      setTimeout(() => {
        tooltipElement.innerHTML = '<div></div>'
        tooltipElement.style.display = 'none';
        tooltipElement.style.opacity = '0';
      }, 100)
    },
  },
  components:{
    GraphApexChart
  }
}
</script>
<style lang='scss'>
.boxElementGraph{
  margin: auto 5px 5px 0;
  width: 16px !important;
  height: 16px !important;
  border: solid 1px black;
  background-color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/Components/graphTable.vue